import React from 'react';
import { Image } from 'react-bootstrap';
import {showImageInNewWindow} from './functions'

export default function ImageAttachments({attachments}) {

  let att = undefined;

  if( attachments ){
    att = attachments.find((att) => {
        return att.attachmentName && att.attachmentName.match(/.(jpg|jpeg|png|gif)$/i)
    });    
  }


  if (att) {
      return (
          <div className="card-image-container"
               onClick={showImageInNewWindow.bind(null, att.attachmentUrl)}>
              <Image src={att.attachmentUrl} thumbnail/>
          </div>
      )
  } else {
      return null;
  }
}